import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { Analytics } from 'Shared/utils/client';
import { LINK } from '@constants';
import { ArrowRight, Button, Column, Icon } from '@viewup/ui';
import { useRouter } from 'next/navigation';
import { supportMenuList } from './SupportMenus.const';

export const SupportMenus = () => {
  const router = useRouter();
  const { accessToken } = useTokenStore();

  return (
    <Column bgColor='system.white' gap={8} p={16}>
      {supportMenuList
        .filter((list) => (accessToken ? list : list.url !== LINK.SUGGEST))
        .map((list) => (
          <Button
            key={list.text}
            onClick={() => {
              Analytics.getInstance().track('MY_VIEWUP_SUPPORT', {
                type: list.type,
              });
              router.push(list.url);
            }}
            rightContent={<Icon color='icon.tertiary' source={ArrowRight} />}
            size={'M'}
            styledComponents={{
              root: {
                color: 'text.tertiary',
                justifyContent: 'space-between',
                width: '100%',
              },
            }}
            variant='ghost.assistive'
          >
            {list.text}
          </Button>
        ))}
    </Column>
  );
};
